var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"label":_vm.label,"value":_vm.value,"rules":_vm.inputNameRules,"hint":_vm.hint},on:{"input":function($event){return _vm.$emit('input-change', { name: _vm.name, value: $event })}}})
}
var staticRenderFns = []

export { render, staticRenderFns }